import React from 'react';

const CategoriesIcon = () => (
 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="11" viewBox="0 0 16 11" fill="none">
  <path d="M0 0H16V3.14286H0V0ZM0 3.92857H16V7.07143H0V3.92857ZM0 7.85714H16V11H0V7.85714Z" fill="currentColor"/>
</svg>
);

export default CategoriesIcon;